import { AuthTypes } from '../ActionTypes/AuthTypes';

let initialSate = {
    isLogin: null,
    user: null,
};

const AuthReducer = (state = initialSate, action) => {
    console.log('stateeee', state);
    console.log('actionnnnn', action);
    switch (action.type) {

        case AuthTypes.GET_USER:
            state = { ...state, user: action.payload };
            break;

        case AuthTypes.UPDATE_USER_PROFILE:
            state = { ...state, user: { ...state.user, user: action.payload } };
            break;
        case AuthTypes.NOTIFICATION_SWITCH:
            state = { ...state, user: { ...state.user, is_receive_notification: action.payload } };
            localStorage.setItem('@user', JSON.stringify(state.user))
            break;

        case AuthTypes.LOGIN:
            state = { ...state, isLogin: action.payload.isLogin ,user:action.payload.userData };
            break;

        case AuthTypes.LOGOUT:
            state = {
                user: null,
                isLogin: false
            };
            break;

        default:
            break;
    }
    return state;
};

export default AuthReducer;
